import React, { useEffect } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { useQuery } from '@apollo/client';

import GET_COMPANY_ID from './GetCompanyId.graphql';

interface MatchParams {
  slug: string;
}

const RedirectToDemo = ({ match }: RouteComponentProps<MatchParams>) => {
  const {
    params: { slug },
  } = match;

  const { data } = useQuery(GET_COMPANY_ID, {
    variables: {
      id: slug,
    },
    errorPolicy: 'all',
  });

  useEffect(() => {
    const companiesDemoUrl = `${window.location.origin}/companies/demo`;
    const id = data?.entityPageEX?.context?.companyId;

    if (id) {
      window.location.assign(`${companiesDemoUrl}/${id}`);
    }
  }, [data]);

  return <div>Redirecting...</div>;
};

export { RedirectToDemo };
